







import { Component, Vue } from 'vue-property-decorator'
import ToastComponent from './components/toast/ToastComponent.vue'

@Component({
  components: {
    ToastComponent
  }
})

export default class App extends Vue {
}
